import { ClipboardList, Layers, QrCode } from "lucide-react";
import { CaixaRegistradoraIcon, MesaIcon, MotoEntregaIcon, TotemIcon } from "@/components/icons/ModulosIcons";

// Canais de venda (módulos) do Relatório de Módulos e da despesa por módulo.
// Ícones iguais aos dos módulos no topo do painel (ModulosIcons, 27/10/2026);
// cores iguais às de Vendas → Pedidos (MODULOS_RESUMO em Pedidos.js);
// logos iguais às de Configurações → Sistema → Integração. A `key` é a mesma
// que o backend usa (api/v1/reports/canais.py) e que a despesa guarda.
export const CANAIS = [
  { key: "mesas", nome: "Mesas", Icon: MesaIcon, cor: "blue", hex: "#3b82f6" },
  { key: "mesa_qr", nome: "Mesa QR", Icon: QrCode, cor: "cyan", hex: "#06b6d4" },
  { key: "comandas", nome: "Comandas", Icon: ClipboardList, cor: "amber", hex: "#f59e0b" },
  { key: "balcao", nome: "Balcão", Icon: CaixaRegistradoraIcon, cor: "purple", hex: "#a855f7" },
  { key: "totem", nome: "Totem", Icon: TotemIcon, cor: "violet", hex: "#8b5cf6" },
  { key: "delivery", nome: "Delivery", Icon: MotoEntregaIcon, cor: "orange", hex: "#f97316" },
  { key: "cardapio", nome: "Cardápio", logo: "/logo-nucleo.png", cor: "pink", hex: "#ec4899" },
  { key: "ifood", nome: "iFood", logo: "/logo-ifood.png", cor: "red", hex: "#ef4444" },
];

export const OUTROS = { key: "outros", nome: "Outros canais", Icon: Layers, cor: "slate", hex: "#64748b" };

export const EM_BREVE = [
  { key: "keeta", nome: "Keeta", logo: "/logo-keeta.png" },
  { key: "99food", nome: "99Food", logo: "/logo-99food.png" },
  { key: "deliverymuch", nome: "Delivery Much", logo: "/logo-deliverymuch.png" },
  { key: "aiqfome", nome: "aiqfome", logo: "/logo-aiqfome.png" },
];

export const canalPorChave = (key) => CANAIS.find((c) => c.key === key) || OUTROS;

// Classes Tailwind escritas por extenso: o build só gera classe que aparece inteira no código.
export const TEMA = {
  blue: { fundo: "from-blue-500/15", anel: "ring-blue-500/25", icone: "bg-blue-500/10 text-blue-600 dark:text-blue-400" },
  cyan: { fundo: "from-cyan-500/15", anel: "ring-cyan-500/25", icone: "bg-cyan-500/10 text-cyan-600 dark:text-cyan-400" },
  purple: { fundo: "from-purple-500/15", anel: "ring-purple-500/25", icone: "bg-purple-500/10 text-purple-600 dark:text-purple-400" },
  violet: { fundo: "from-violet-500/15", anel: "ring-violet-500/25", icone: "bg-violet-500/10 text-violet-600 dark:text-violet-400" },
  orange: { fundo: "from-orange-500/15", anel: "ring-orange-500/25", icone: "bg-orange-500/10 text-orange-600 dark:text-orange-400" },
  pink: { fundo: "from-pink-500/15", anel: "ring-pink-500/25", icone: "bg-pink-500/10 text-pink-600 dark:text-pink-400" },
  red: { fundo: "from-red-500/15", anel: "ring-red-500/25", icone: "bg-red-500/10 text-red-600 dark:text-red-400" },
  // Comandas (24/10/2026) nasceu "amber" sem tema aqui e derrubava o Relatório de Módulos
  amber: { fundo: "from-amber-500/15", anel: "ring-amber-500/25", icone: "bg-amber-500/10 text-amber-600 dark:text-amber-400" },
  slate: { fundo: "from-slate-500/15", anel: "ring-slate-500/25", icone: "bg-slate-500/10 text-slate-600 dark:text-slate-400" },
};

/** Tema do canal; cor sem tema cai no cinza em vez de quebrar a tela. */
export const temaDoCanal = (canal) => TEMA[canal?.cor] || TEMA.slate;
